var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button solid black small",style:('--accent:' + this.accent),attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleQuestions()}}},[_vm._m(0),_vm._v("\n\tComplete\n")])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"fa-stack fa-1x"},[_c('i',{staticClass:"fal fa-circle fa-stack-2x"}),_vm._v(" "),_c('i',{staticClass:"fas fa-question fa-stack-1x"})])
}]

export { render, staticRenderFns }